import React from 'react'
import styled from 'styled-components'
import { ConfigConsumer } from 'contexts/config-context'
import { ThemeConsumer } from 'contexts/theme-context'
import { Link, MainLogo, NetworkTag } from 'atoms'

const Wrapper = styled.div`
  padding: 12px;
`

const ButtonWrapper = styled.div`
  display: flex;

  a {
    flex: 1;
  }

  a:first-child {
    margin: 0 12px 0 0;
  }
`

const LogoWrapper = styled.div`
  margin: 12px 0;
  display: flex;
  justify-content: center;
`

function LoggedOutTopper(props) {
  return (
    <Wrapper>
      <NetworkTag />
      <LogoWrapper>
        <ThemeConsumer>{(theme) => <MainLogo wordmark={theme.wordmarkMobile || theme.wordmark} />}</ThemeConsumer>
      </LogoWrapper>
      <ButtonWrapper>
        <ConfigConsumer>
          {(config) => {
            return (
              <React.Fragment>
                <Link href={config.loginUrl} type="button">
                  Login
                </Link>
                <Link href={config.signupUrl} type="button" theme="primary">
                  Sign Up
                </Link>
              </React.Fragment>
            )
          }}
        </ConfigConsumer>
      </ButtonWrapper>
    </Wrapper>
  )
}

export default LoggedOutTopper



// WEBPACK FOOTER //
// ./src/molecules/UserProfile/components/LoggedOutTopper.js